import LinkedIn from "../../assets/svg/linkedin.svg";
import LeetCode from "../../assets/svg/leetcode.svg";
import GitHub from "../../assets/svg/github.svg";
import Instagram from "../../assets/svg/instagram.svg";
import Whatsapp from "../../assets/svg/whatsapp.svg";
import Gmail from "../../assets/svg/gmail.svg";
export const socialLinks = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/jaividyasagar/",
    icon: LinkedIn,
  },
  {
    name: "LeetCode",
    link: "https://leetcode.com/Jaividyasagar/",
    icon: LeetCode,
  },
  { name: "Gmail", link: "mailto:jaividyasagarr@gmail.com", icon: Gmail },
  { name: "GitHub", link: "https://github.com/Jaividyasagar/", icon: GitHub },
  {
    name: "Instagram",
    link: "https://instagram.com/jaividyasagar/",
    icon: Instagram,
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/+919500442237?text=Hey%20Jai%20Vidyasagar%20R",
    icon: Whatsapp,
  }
];
